export const modalTitle = 'Disconnect Facebook Page';
export const modalDescription =
  'Disconnecting this Facebook Page will stop all messaging and' +
  ' other services that MobileMonkey is providing for';

export const igModalTitle = 'Disconnect Instagram Account';
export const igModalDescription = (pageName: string) =>
  `Disconnecting this Instagram Account will stop all messaging and other services
   that MobileMonkey is providing for ${pageName}. Are you sure you want to disconnect?`;
